export default __webpack_public_path__ + "static/media/dtsu5168_ct_shunt_trip.e13532ad.png";